import { UserRole } from '@synergy/models';

import { hasOneOf } from './has-one-of';

// TODO: Can be removed when user model is shared
interface UserWithRoles {
    roles?: UserRole[];
}

export const hasRole = (neededRole: UserRole | UserRole[], user?: UserWithRoles | null) => {
    return hasOneOf(neededRole, user?.roles);
};
